import {isNullOrEmpty} from '../actions/website-actions';

export const RESET_STATE = "RESET_STATE";
export const ACTION_SET_PAGETYPE = "ACTION_SET_PAGETYPE";

export const ACTION_FETCH_WEBSITESETTINGS = "FETCH_WEBSITESETTINGS";
export const ACTION_FETCH_WEBSITESETTINGS_PENDING = "FETCH_WEBSITESETTINGS_PENDING";
export const ACTION_FETCH_WEBSITESETTINGS_FULLFILLED = "FETCH_WEBSITESETTINGS_FULFILLED";
export const ACTION_FETCH_WEBSITESETTINGS_REJECTED = "FETCH_WEBSITESETTINGS_REJECTED";

export const ACTION_FETCH_PAGE_PENDING = "FETCH_PAGE_PENDING";
export const ACTION_FETCH_PAGE_FULLFILLED = "FETCH_PAGE_FULFILLED";
export const ACTION_FETCH_PAGE_REJECTED = "FETCH_PAGE_FULFILLED";

export const ACTION_SHOW_LOGIN = "SHOW_LOGIN";
export const ACTION_HIDE_LOGIN = "HIDE_LOGIN";

export const ACTION_SHOW_FILTER = "SHOW_FILTER";
export const ACTION_HIDE_FILTER = "HIDE_FILTER";

export const ACTION_FETCH_LOGIN_PENDING = "FETCH_LOGIN_PENDING";
export const ACTION_FETCH_LOGIN_FULFILLED = "FETCH_LOGIN_FULFILLED";
export const ACTION_FETCH_LOGIN_REJECTED = "FETCH_LOGIN_REJECTED";
export const ACTION_LOGIN_CLEARERROR = "ACTION_LOGIN_CLEARERROR";

export const ACTION_FETCH_DICT_PENDING = "FETCH_DICT_PENDING";
export const ACTION_FETCH_DICT_FULFILLED = "FETCH_DICT_FULFILLED";
export const ACTION_FETCH_DICT_REJECTED = "FETCH_DICT_REJECTED";

export const ACTION_SAVE_PATHS = "SAVE_PATHS";

export const TOKEN_URL = 'https://oauth.swinity.com/connect/token';
export function ROOT_URL(appUrl = "") {
  //if(typeof window !== "undefined") {
  //  return isNullOrEmpty(appUrl) ? 'https://app.swinity.com/api' : appUrl + "/api";
  //} else {
    return 'https://app.swinity.com/api';
  //}
}


export const APP_VERSION = "1.11.24";

export const LOGIN_STATUS_GUEST = "LOGIN_STATUS_GUEST";
export const LOGIN_STATUS_PENDING = "LOGIN_STATUS_PENDING";
export const LOGIN_STATUS_FAILED = "LOGIN_STATUS_FAILED";
export const LOGIN_STATUS_APPROVED = "LOGIN_STATUS_APPROVED";

export const ACTION_SUPPORT_GET = "SUPPORT_GET";
export const ACTION_SUPPORT_GET_PENDING = "SUPPORT_GET_PENDING";
export const ACTION_SUPPORT_GET_FULFILLED = "SUPPORT_GET_FULLFILLED";
export const ACTION_SUPPORT_GET_FAILED = "SUPPORT_GET_FAILED";

export const ACTION_SUPPORT_SENDMESSAGE_PENDING = "SUPPORT_SENDMESSAGE_PENDING";
export const ACTION_SUPPORT_SENDMESSAGE_FULFILLED = "SUPPORT_SENDMESSAGE_FULLFILLED";
export const ACTION_SUPPORT_SENDMESSAGE_FAILED = "SUPPORT_SENDMESSAGE_FAILED";

export const SUPPORT_STATUS_NEW = "SUPPORT_STATUS_NEW";
export const SUPPORT_STATUS_PENDING = "SUPPORT_STATUS_PENDING";
export const SUPPORT_STATUS_SUCCESS = "SUPPORT_STATUS_SUCCESS";
export const SUPPORT_STATUS_FAILED = "SUPPORT_STATUS_FAILED";

export const SIGNUP_SET_TYPE = "SIGNUP_SET_TYPE";
export const SIGNUP_STATUS_NEW = "SIGNUP_STATUS_NEW";
export const SIGNUP_STATUS_PENDING = "SIGNUP_STATUS_PENDING";
export const SIGNUP_STATUS_SUCCESS = "SIGNUP_STATUS_SUCCESS";
export const SIGNUP_STATUS_FAILED = "SIGNUP_STATUS_FAILED";

export const ACTION_PROFILE_SENDMESSAGE = "PROFILE_SENDMESSAGE";
export const ACTION_PROFILE_SENDMESSAGE_PENDING = "PROFILE_SENDMESSAGE_PENDING";
export const ACTION_PROFILE_SENDMESSAGE_FULFILLED = "PROFILE_SENDMESSAGE_FULLFILLED";
export const ACTION_PROFILE_SENDMESSAGE_FAILED = "PROFILE_SENDMESSAGE_FAILED";

export const ACTION_ENABLE_FORCEXL = "ACTION_ENABLE_FORCEXL";
export const ACTION_DISABLE_FORCEXL = "ACTION_DISABLE_FORCEXL";



export const ALERT_WARNING_SUCCESS = "ALERT_WARNING_SUCCESS";
export const ALERT_WARNING_FAILED = "ALERT_WARNING_FAILED";
export const ALERT_WARNING_WARNING = "ALERT_WARNING_WARNING";
export const HIDE_WARNING = "HIDE_WARNING";
export const SHOW_WARNING = "SHOW_WARNING";

export const CONFIRM_STATUS_NEW = "CONFIRM_STATUS_NEW";
export const CONFIRM_STATUS_PENDING = "CONFIRM_STATUS_PENDING";
export const CONFIRM_STATUS_SUCCESS = "CONFIRM_STATUS_SUCCESS";
export const CONFIRM_STATUS_FAILED = "CONFIRM_STATUS_FAILED";

export const SEO_STATUS_NEW =  "SEO_STATUS_NEW";
export const SEO_ACTION_CLOSE =  "SEO_ACTION_CLOSE";
export const SEO_STATUS_LOADING =  "SEO_STATUS_LOADING";
export const SEO_STATUS_LOADED =  "SEO_STATUS_LOADED";
export const SEO_ACTION_PREVIEW =  "SEO_ACTION_PREVIEW";
export const SEO_ACTION_EDIT =  "SEO_ACTION_EDIT";
export const SEO_STATUS_VIEW =  "SEO_STATUS_VIEW";
export const SEO_STATUS_PENDING =  "SEO_STATUS_PENDING";
export const SEO_STATUS_SUCCESS =  "SEO_STATUS_SUCCESS";

export const MSG_STATUS_NEW =  "MSG_STATUS_NEW";
export const MSG_ACTION_CLOSE =  "MSG_ACTION_CLOSE";
export const MSG_ACTION_PREVIEW =  "MSG_ACTION_PREVIEW";
export const MSG_ACTION_EDIT =  "MSG_ACTION_EDIT";
export const MSG_STATUS_VIEW =  "MSG_STATUS_VIEW";
export const MSG_STATUS_PENDING =  "MSG_STATUS_PENDING";
export const MSG_STATUS_SUCCESS =  "MSG_STATUS_SUCCESS";

export const RESET_STATUS_NEW = "RESET_STATUS_NEW";
export const RESET_STATUS_PENDING = "RESET_STATUS_PENDING";
export const RESET_STATUS_SUCCESS = "RESET_STATUS_SUCCESS";
export const RESET_STATUS_FAILED = "RESET_STATUS_FAILED";

export const RESET_CONFIRM_STATUS_NEW = "RESET_CONFIRM_STATUS_NEW";
export const RESET_CONFIRM_STATUS_PENDING = "RESET_CONFIRM_STATUS_PENDING";
export const RESET_CONFIRM_STATUS_SUCCESS = "RESET_CONFIRM_STATUS_SUCCESS";
export const RESET_CONFIRM_STATUS_FAILED = "RESET_CONFIRM_STATUS_FAILED";

export const ACTION_FETCH_BLOGPOSTS_PENDING = "FETCH_BLOGPOSTS_PENDING";
export const ACTION_FETCH_BLOGPOSTS_FULLFILLED = "FETCH_BLOGPOSTS_FULFILLED";
export const ACTION_FETCH_BLOGPOSTS_REJECTED = "FETCH_BLOGPOSTS_REJECTED";

export const ACTION_FETCH_BLOGPOST_PENDING = "FETCH_BLOGPOST_PENDING";
export const ACTION_FETCH_BLOGPOST_FULLFILLED = "FETCH_BLOGPOST_FULFILLED";
export const ACTION_FETCH_BLOGPOST_REJECTED = "FETCH_BLOGPOST_REJECTED";
export const ACTION_SET_BLOGPATH = "ACTION_SET_BLOGPATH";

export const ACTION_FETCH_AGENCYLIST_PENDING = "FETCH_AGENCYLIST_PENDING";
export const ACTION_FETCH_AGENCYLIST_FULLFILLED = "FETCH_AGENCYLIST_FULFILLED";
export const ACTION_FETCH_AGENCYLIST_REJECTED = "FETCH_AGENCYLIST_REJECTED";

export const ACTION_FETCH_AGENCYPROFILE_PENDING = "FETCH_AGENCYPROFILE_PENDING";
export const ACTION_FETCH_AGENCYPROFILE_FULLFILLED = "FETCH_AGENCYPROFILE_FULFILLED";
export const ACTION_FETCH_AGENCYPROFILE_REJECTED = "FETCH_AGENCYPROFILE_REJECTED";

export const FETCH_SEARCH_PENDING = "FETCH_SEARCH_PENDING";
export const FETCH_SEARCH_FULLFILLED = "FETCH_SEARCH_FULFILLED";
export const FETCH_SEARCH_REJECTED = "FETCH_SEARCH_REJECTED";

export const FETCH_SEARCHGROUPS_PENDING = "FETCH_SEARCHGROUPS_PENDING";
export const FETCH_SEARCHGROUPS_FULLFILLED = "FETCH_SEARCHGROUPS_FULFILLED";
export const FETCH_SEARCHGROUPS_REJECTED = "FETCH_SEARCHGROUPS_REJECTED";


export const FETCH_SITEMAP_PENDING = "FETCH_SITEMAP_PENDING";
export const FETCH_SITEMAP_FULLFILLED = "FETCH_SITEMAP_FULFILLED";
export const FETCH_SITEMAP_REJECTED = "FETCH_SITEMAP_REJECTED";

export const ACTION_SHOWINGIMAGES = "ACTION_SHOWINGIMAGES";
export const ACTION_HIDINGIMAGES = "ACTION_HIDINGIMAGES";

export const FILTER_PAGESIZE = 24;


export const FETCH_SSRADS_PENDING = "FETCH_SSRADS_PENDING";
export const FETCH_SSRADS_REJECTED = "FETCH_SSRADS_REJECTED";
export const FETCH_SSRADS_FULLFILLED = "FETCH_SSRADS_FULLFILLED";

export const ACTION_LINKBANNERS_PENDING = "ACTION_LINKBANNERS_PENDING";
export const ACTION_LINKBANNERS_SUCCESS = "ACTION_LINKBANNERS_SUCCESS";
export const ACTION_LINKBANNERS_FAILURE = "ACTION_LINKBANNERS_FAILURE";

